import { render, staticRenderFns } from "./TransactionDetailsForm.vue?vue&type=template&id=4a795609"
import script from "./TransactionDetailsForm.vue?vue&type=script&lang=js"
export * from "./TransactionDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports